import {styled} from '@mui/material/styles';
import {Button, Divider} from '@mui/material';
import {Dispatch, Fragment} from 'react';

import {FilterDialogSectionId, FilterDialogSection} from 'filters/features/FilterDialog/types';

import {useFilterDialogContext} from 'filters/features/FilterDialog/contexts/FilterDialogProvider/FilterDialogProvider';
import {shouldNotForwardProp} from 'utils/styled';

const SRoot = styled('div')(() => ({
  overflowY: 'auto',
}));

const SButton = styled(
  Button,
  shouldNotForwardProp('active')
)<{
  active: boolean;
}>(({theme, active}) => ({
  ...theme.typography.body2,
  justifyContent: 'start',
  padding: theme.spacing(2, 4),
  color: active ? theme.palette.primary.main : theme.palette.text.primary,
  transition: 'none',

  svg: {
    width: 16,
    height: 16,
    color: active ? theme.palette.primary.main : theme.palette.text.secondary,
  },

  '&:hover': {
    color: theme.palette.primary.main,

    svg: {
      color: theme.palette.primary.main,
    },
  },

  // '&.disabled, &.disabled:hover': {
  //   color: theme.palette.text.disabled,
  //   cursor: 'default',
  //   backgroundColor: 'unset',
  //
  //   svg: {
  //     color: theme.palette.text.disabled,
  //   },
  // },

  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2, 4),
  },
}));

const SDivider = styled(Divider)(({theme}) => ({
  margin: theme.spacing(2, 0),
}));

const SectionItem = ({
  activeId,
  setActiveId,
  section,
  dataTestId,
}: {
  activeId: FilterDialogSectionId;
  setActiveId: Dispatch<FilterDialogSectionId>;
  section: FilterDialogSection;
} & DataTestId) => {
  const Icon = section.icon;

  return (
    <Fragment key={section.id}>
      <SButton
        key={section.id}
        fullWidth
        startIcon={Icon && <Icon height={16} width={16} />}
        active={section.id === activeId}
        onClick={() => setActiveId(section.id)}
        data-testid={dataTestId}
      >
        <span>{section.title}</span>
      </SButton>
      {section.withDivider && <SDivider />}
    </Fragment>
  );
};

export const SectionSelector = ({
  activeId,
  setActiveId,
}: {
  activeId: FilterDialogSectionId;
  setActiveId: Dispatch<FilterDialogSectionId>;
} & DataTestId) => {
  const {sections} = useFilterDialogContext();

  return (
    <SRoot>
      {sections.map(section => (
        <SectionItem
          key={section.id}
          activeId={activeId}
          setActiveId={setActiveId}
          section={section}
          dataTestId={`filter-dialog-section-selector-${section.id}`}
        />
      ))}
    </SRoot>
  );
};
